// Librearies
import { FC } from "react";

// Components
import { ModalTitle } from "../ModalTitle/ModalTitle";
import { ModalSubtitle } from "../ModalSubtitle/ModalSubtitle";
import { ModalTitleIcon } from "../ModalTitleIcon/ModalTitleIcon";
import { PanelHeader } from "../PanelHeader/PanelHeader";

// Types
import { ModalHeaderProps } from "./ModalHeader.types";
import { cn } from "utils/cn";

export const ModalHeader: FC<ModalHeaderProps> = ({
  title,
  icon,
  subtitle,
  onClose,
  closeDisabled,
  layout = "default",
  className,
}) => {
  if (layout === "panel") {
    return (
      <div data-testid="modal-header">
        <PanelHeader
          title={title}
          icon={icon}
          subtitle={subtitle}
          onClose={onClose}
          closeDisabled={closeDisabled}
          className={className}
          useDialogTitle
        />
      </div>
    );
  }

  return (
    <div
      className={cn("flex flex-col", subtitle ? "gap-0.5" : "gap-2", className)}
      data-testid="modal-header"
    >
      <ModalTitle onClose={onClose}>
        {icon ? (
          <>
            <ModalTitleIcon>{icon}</ModalTitleIcon>
            {title}
          </>
        ) : (
          title
        )}
      </ModalTitle>
      <ModalSubtitle>{subtitle}</ModalSubtitle>
    </div>
  );
};

export default ModalHeader;
